import React from 'react';
import { Facebook, Twitter, Instagram, Youtube, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-neutral-900 pt-16 pb-8" data-id="element-65">
      <div className="container mx-auto px-4" data-id="element-66">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-67">
          <div className="col-span-1 md:col-span-2" data-id="element-68">
            <h2 className="text-3xl font-black text-white uppercase italic tracking-tighter mb-6" data-id="element-69">
              Jeuxtremiste
            </h2>
            <p className="text-neutral-500 max-w-sm mb-6" data-id="element-70">
              The definitive platform for extreme sports gaming. Where
              adrenaline meets the digital frontier.
            </p>
            <div className="flex items-start gap-3 text-neutral-400" data-id="element-71">
              <MapPin className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-72" />
              <address className="not-italic" data-id="element-73">
                Limassol, Cyprus
                <br data-id="element-74" />
                Mediterranean Tech Hub
                <br data-id="element-75" />
                3036
              </address>
            </div>
          </div>

          <div data-id="element-76">
            <h3 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-77">
              Platform
            </h3>
            <ul className="space-y-4 text-neutral-500" data-id="element-78">
              <li data-id="element-79">
                <a href="#" className="hover:text-red-600 transition-colors" data-id="element-80">
                  Tournaments
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-red-600 transition-colors" data-id="element-82">
                  Creators
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-red-600 transition-colors" data-id="element-84">
                  Premium
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-red-600 transition-colors" data-id="element-86">
                  Support
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-87">
            <h3 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-88">
              Connect
            </h3>
            <div className="flex gap-4" data-id="element-89">
              <a href="#" className="w-10 h-10 bg-neutral-900 flex items-center justify-center text-white hover:bg-red-600 transition-colors" data-id="element-90">
                <Twitter className="w-5 h-5" data-id="element-91" />
              </a>
              <a href="#" className="w-10 h-10 bg-neutral-900 flex items-center justify-center text-white hover:bg-red-600 transition-colors" data-id="element-92">
                <Instagram className="w-5 h-5" data-id="element-93" />
              </a>
              <a href="#" className="w-10 h-10 bg-neutral-900 flex items-center justify-center text-white hover:bg-red-600 transition-colors" data-id="element-94">
                <Youtube className="w-5 h-5" data-id="element-95" />
              </a>
              <a href="#" className="w-10 h-10 bg-neutral-900 flex items-center justify-center text-white hover:bg-red-600 transition-colors" data-id="element-96">
                <Facebook className="w-5 h-5" data-id="element-97" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-98">
          <p className="text-neutral-600 text-sm" data-id="element-99">
            © 2026 Jeuxtremiste. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-neutral-600" data-id="element-100">
            <a href="#" className="hover:text-white transition-colors" data-id="element-101">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-102">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}